<template>
    <v-container class="ma-0 pa-0 mt-3" fill-height>
        <v-row dense class="ma-0 pa-0 mx-5">
            <v-col cols="3" align="center" class="ma-0 pa-0">
                <img
                    :src="iconPath"
                    :alt="disease"
                    class="disease-icon"
                />
            </v-col>
            <v-col cols="9" align="left">
                <p class="disease-name">
                    {{ disease }} <span v-html="diseaseBedge"/>
                </p>
                <p class="warningLevel" :class="warning" v-html="diseaseStatus" />
                <p class="description"> {{diseaseDescription}} </p>
            </v-col>
        </v-row>

        <v-divider class="mx-7 pa-0" style="border-color:#e2e6ea;"/>
    </v-container>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
        props: {
            disease: {
                type: String,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        computed: {
            warning() {
                if(this.disease.index > 1)
                    return 'warning'
                return ''
            },
            iconPath() {
                switch(this.disease) {
                    case '당뇨병': return require('@/assets/images/renew/ico-diabetes-90-x-90.svg')
                    case '간암': return require('@/assets/images/renew/ico-liver-cancer-90-x-90.svg')
                    case '대장암': return require('@/assets/images/renew/ico-colon-cancer-90-x-90.svg')
                    case '위암': return require('@/assets/images/renew/ico-gastric-cancer-90-x-90.svg')
                    case '폐암': return require('@/assets/images/renew/ico-lung-cancer-90-x-90.svg')
                    case '전립선암': return require('@/assets/images/renew/ico-prostate-cancer-90-x-90.svg')
                    case '유방암': return require('@/assets/images/renew/ico-breast-cancer-90-x-90.svg')
                    case '치매': return require('@/assets/images/renew/ico-dementia-90-x-90.svg')
                    case '심장질환': return require('@/assets/images/renew/ico-heart-90-x-90.svg')
                    case '뇌졸중': return require('@/assets/images/renew/ico-stroke-90-x-90.svg')
                }
            },
            diseaseStatus() {
                if(this.index < 0) {
                    return ''
                }
                else if(this.index <= 1) {
                    switch(this.disease) {
                        case '당뇨병': return this.$t('disease.DM.normal.title')
                        case '간암': return this.$t('disease.LIVER.normal.title')
                        case '대장암': return this.$t('disease.COLORECTAL.normal.title')
                        case '위암': return this.$t('disease.STOMACH.normal.title')
                        case '폐암': return this.$t('disease.LUNG.normal.title')
                        case '전립선암': return this.$t('disease.PROSTATE.normal.title')
                        case '유방암': return this.$t('disease.BREAST.normal.title')
                        case '치매': return this.$t('disease.DEMENTIA.normal.title')
                        case '심장질환': return this.$t('disease.HEART.normal.title')
                        case '뇌졸중': return this.$t('disease.STROKE.normal.title')
                    }
                }
                else if(this.index > 1 && this.index <= 3) {
                    switch(this.disease) {
                        case '당뇨병': return this.$t('disease.DM.warning.title')
                        case '간암': return this.$t('disease.LIVER.warning.title')
                        case '대장암': return this.$t('disease.COLORECTAL.warning.title')
                        case '위암': return this.$t('disease.STOMACH.warning.title')
                        case '폐암': return this.$t('disease.LUNG.warning.title')
                        case '전립선암': return this.$t('disease.PROSTATE.warning.title')
                        case '유방암': return this.$t('disease.BREAST.warning.title')
                        case '치매': return this.$t('disease.DEMENTIA.warning.title')
                        case '심장질환': return this.$t('disease.HEART.warning.title')
                        case '뇌졸중': return this.$t('disease.STROKE.warning.title')
                    }
                }
            },
            diseaseDescription() {
                if(this.index < 0) {
                    return this.$t('disease.not-available')
                }
                else if(this.index <= 1) {
                    switch(this.disease) {
                        case '당뇨병': return this.$t('disease.DM.normal.desc')
                        case '간암': return this.$t('disease.LIVER.normal.desc')
                        case '대장암': return this.$t('disease.COLORECTAL.normal.desc')
                        case '위암': return this.$t('disease.STOMACH.normal.desc')
                        case '폐암': return this.$t('disease.LUNG.normal.desc')
                        case '전립선암': return this.$t('disease.PROSTATE.normal.desc')
                        case '유방암': return this.$t('disease.BREAST.normal.desc')
                        case '치매': return this.$t('disease.DEMENTIA.normal.desc')
                        case '심장질환': return this.$t('disease.HEART.normal.desc')
                        case '뇌졸중': return this.$t('disease.STROKE.normal.desc')
                    }
                }
                else if(this.index > 1 && this.index <= 3) {
                    switch(this.disease) {
                        case '당뇨병': return this.$t('disease.DM.warning.desc')
                        case '간암': return this.$t('disease.LIVER.warning.desc')
                        case '대장암': return this.$t('disease.COLORECTAL.warning.desc')
                        case '위암': return this.$t('disease.STOMACH.warning.desc')
                        case '폐암': return this.$t('disease.LUNG.warning.desc')
                        case '전립선암': return this.$t('disease.PROSTATE.warning.desc')
                        case '유방암': return this.$t('disease.BREAST.warning.desc')
                        case '치매': return this.$t('disease.DEMENTIA.warning.desc')
                        case '심장질환': return this.$t('disease.HEART.warning.desc')
                        case '뇌졸중': return this.$t('disease.STROKE.warning.desc')
                    }
                }
            },
            diseaseBedge() {
                if(this.index < 0) {
                    return ''
                }
                else if(this.index <= 1) {
                    switch(this.disease) {
                        case '당뇨병': return this.$t('disease.DM.normal.state')
                        case '간암': return this.$t('disease.LIVER.normal.state')
                        case '대장암': return this.$t('disease.COLORECTAL.normal.state')
                        case '위암': return this.$t('disease.STOMACH.normal.state')
                        case '폐암': return this.$t('disease.LUNG.normal.state')
                        case '전립선암': return this.$t('disease.PROSTATE.normal.state')
                        case '유방암': return this.$t('disease.BREAST.normal.state')
                        case '치매': return this.$t('disease.DEMENTIA.normal.state')
                        case '심장질환': return this.$t('disease.HEART.normal.state')
                        case '뇌졸중': return this.$t('disease.STROKE.normal.state')
                    }
                }
                else if(this.index > 1 && this.index <= 3) {
                    switch(this.disease) {
                        case '당뇨병': return this.$t('disease.DM.warning.state')
                        case '간암': return this.$t('disease.LIVER.warning.state')
                        case '대장암': return this.$t('disease.COLORECTAL.warning.state')
                        case '위암': return this.$t('disease.STOMACH.warning.state')
                        case '폐암': return this.$t('disease.LUNG.warning.state')
                        case '전립선암': return this.$t('disease.PROSTATE.warning.state')
                        case '유방암': return this.$t('disease.BREAST.warning.state')
                        case '치매': return this.$t('disease.DEMENTIA.warning.state')
                        case '심장질환': return this.$t('disease.HEART.warning.state')
                        case '뇌졸중': return this.$t('disease.STROKE.warning.state')
                    }
                }
            },
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
<style scoped>
    .diesease-card-detail {
        text-align: center;
    }
    .disease-icon {
        width: 80px;
    }
    .disease-name {
        color: #193263;
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 18px;
        letter-spacing: -0.86px;
        margin-top: 8px;
        margin-bottom: 4px;
    }
    .warningLevel {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.6px;
        color: #475b82;
    }
    .blue {
        background-color: #00afef;
    }
    .description {
        font-family: "NanumSquare", sans-serif;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.6px;
        color: #475b82;
    }
    .seperator {
        height: 1px;
        width: 100%;
        background-color: #000;
        margin-bottom: 40px;
    }

</style>
